import React from "react";
import {Link} from "react-router-dom";

function PageAbout()
{   
    return (
        <div style={{
            height: "100vh",
            backgroundColor: "white",
            boxSizing: "border-box",
            paddingRight: "5vw",
            paddingLeft: "5vw",
            paddingTop: "8vh",
            textAlign: "center"
        }}>
            <h1>About Snowp</h1>
            <p>Snowp is an independent Dutch developer with a passion for computers and everything related to them.</p>
            <br/>
            <p>Due to my experience in many different areas of software, I am able to write reliable software from scratch or contribute to existing projects with great expertise.<br/>I prefer to stay anonymous, and I spend most of my time working on either personal projects or on projects for clients.</p>
            <p>Whether you want to talk about becoming a client or just have an interesting conversation, feel free to contact me! I'd love to have a chat.</p>
            {/*<h1>Contact me</h1>*/}
            {/*<p>You can contact me through Discord or by sending an email to <a href="mailto:hi@snowp.io">hi@snowp.io</a></p>*/}
            {/*<p>You can contact me through either option below.</p>*/}
            <div style={{
                display: "flex",
                width: "100%",
                marginTop: "30px",
                boxSizing: "border-box",
                minHeight: "400px",
            }} className={"mobile-columns"}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div>
                        {/*
                        <img src={process.env.PUBLIC_URL + "/discord.png"} alt="Snowp on Discord" style={{
                            borderRadius: 9999,
                            maxWidth: "200px",
                        }} />
                        <br/>*/}
                        <h1 style={{
                            marginBottom: 0
                        }}>Snowp#4826</h1>
                        <p style={{
                            marginTop: "10px"
                        }}>on Discord</p>
                    </div>
                </div>
                {/*
                <form style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexFlow: "column",
                    padding: "30px 10px",
                }} action="/contact/me" method="POST" className={"mobile-columns-split"}>
                    <input type="text" placeholder="Your name" name="name" autoComplete="off"/><br/>
                    <input type="email" placeholder="Your email address" name="email"/><br/>
                    <textarea placeholder="Your message" name="message"/><br/>
                    <button type="submit" className="btn" disabled={true}>Submit (still setting it up)</button>
                </form>*/}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }} className={"mobile-columns-split"}>
                    <div>
                        <h1 style={{
                            marginBottom: 0
                        }}>hi@snowp.io</h1>
                        <p style={{
                            marginTop: "10px"
                        }}>by e-mail</p>
                    </div>
                </div>
            </div>
            <br/><br/>
            <a href="/privacy.txt" target="_blank">Privacy Policy</a>
        </div>
    )
}

export default PageAbout;
